module.exports = __webpack_public_path__ + "img/cooperativeScheme.76443598.png";